<template>
  <div class="page-container">
    <v-container class="container-general container-fluid">
      <v-row class="row-breadcrumbs">
        <v-col cols="12" sm="12" md="12">
          <v-breadcrumbs :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
      </v-row>
      <div style="display: flex">
        <div id="geneldiv" class="gwidth">
          <v-form ref="form" lazy-validation>
            <AgentsandAreaInformation
              :requireds="[
                { key: 'area', rules: [val => !!val || 'Zorunlu alan!'] },
                { key: 'source', rules: [val => !!val || 'Zorunlu alan!'] },
                { key: 'agent', rules: [val => !!val || 'Zorunlu alan!'] },
              ]"
            ></AgentsandAreaInformation>
            <PriceAndProductInformation @sorgula="sorgula">
              <template #btn="{ tarifeKodu, dates }">
                <v-btn color="primary" @click="sorgula({ tarifeKodu, dates })">Sorgula</v-btn>
              </template>
            </PriceAndProductInformation>
          </v-form>
          <v-form ref="saveform" lazy-validation>
            <SearchInfo :policeler="policeler" :teminatlar="teminatlar" @save="save"></SearchInfo>
          </v-form>
        </div>
        <div id="sorgu" class="left-pane">
          <v-data-table :items="havuzlar" :headers="jobsHeader">
            <template #top>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field v-model="poolNo" label="Havuz No" dense prepend-icon="mdi-select-search" hide-details>
                </v-text-field>
              </v-card-actions>
            </template>
            <template #[`item.ISLEM_TARIHI`]="{ item }">
              {{ new Date(item.ISLEM_TARIHI) | dateFormat }}
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn @click="sendMailJobResult(item)">Sonuçları Mail ile Al</v-btn>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { parameters as getParameters } from './statics';
import AgentsandAreaInformation from '@/components/AgentsandAreaInformation.vue';
import PriceAndProductInformation from './PriceAndProductInformation.vue';
import SearchInfo from './SearchInfo.vue';
import { eventBus } from '@/main';
export default {
  name: 'BedelArtisHavuzu',
  components: {
    AgentsandAreaInformation,
    PriceAndProductInformation,
    SearchInfo,
  },
  data: () => ({
    agentFilter: {},
    search: '',
    searchHavuz: '',
    queryModel: {
      sirketKod: 1,
    },
    policeler: [],
    polHeaders: [
      {
        text: '',
        value: 'select',
      },
      {
        text: 'Poliçe No',
        value: 'cari_pol_no',
      },
      {
        text: 'Tarife Kodu',
        value: 'tarife_kod',
      },
      {
        text: 'Başlama/Bitiş Tarihi',
        value: 'baslama_tarih',
      },
      {
        text: 'Sigortalı Ad/Soyad',
        value: 'sigortali_ismi',
      },
    ],
    temHeaders: [
      {
        text: 'Teminat Kodu',
        value: 'name',
      },
      {
        text: 'Teminat Adı',
        value: 'description',
      },
      {
        text: 'Oran %',
        value: 'value',
      },
    ],
    jobsHeader: [
      {
        text: 'Havuz Tip',
        value: 'HAVUZ_TIP',
      },
      {
        text: 'Havuz No',
        value: 'HAVUZ_NO',
      },
      {
        text: 'İşlem Tarihi',
        value: 'ISLEM_TARIHI',
      },
      {
        text: 'İşlem Yapan',
        value: 'ISLEM_OP_ID',
      },
      {
        text: 'Çalıştı Mı?',
        value: 'CALISTI',
      },
      {
        text: 'Başarılı Mı?',
        value: 'BASARILI',
      },
      {
        text: 'Aktif Mi?',
        value: 'AKTIF_PASIF',
      },
      {
        text: 'Hata Aldı Mi?',
        value: 'HATA_ALDI',
      },
      {
        text: '',
        value: 'actions',
      },
    ],
    filterPoliceler: null,
    havuzlar: [],
    filterHavuzlar: [],
    poolNo: null,
    page: 1,
    havuzPage: 1,
    pages: 0,
    havuzPages: 0,
    splitPagesCount: [],
    pagPage: 30,
    havuzPagPage: 10,
    localPage: 1,
    totalVisible: null,
    totalVisibleHavuz: null,
    maxButtons: 10,
    maxButtonsHavuz: 10,
    length: 0,
    havuzLength: 0,
    endDates: [],
    tab: '',
  }),
  async mounted() {
    this.filterPoliceler = Object.assign([], this.policeler);
  },
  methods: {
    async sendMailJobResult({ HAVUZ_NO, HAVUZ_TIP }) {
      let ret = await this.$store.dispatch('sendMailAndUpdatePoolJobs', {
        guid: this.$store.state.login.agencyDetails.UserGuid,
        policeHavuzJob: { HAVUZ_NO, HAVUZ_TIP },
        updateJob: false,
      });
      if (ret.status == 204) {
        eventBus.$emit('InfoSnackbar', {
          statePath: {
            Mesajlar: [
              {
                Tip: 'Bilgi',
                Mesaj: 'Mail gonderilmistir!',
              },
            ],
          },
        });
      }
    },
    async save({ secilenPoliceler, teminatlar, emails }) {
      if (!this.$refs.saveform.validate()) return;
      var data = {
        PolItemList: secilenPoliceler.map(x => {
          const { checked, ...ret } = x;
          ret.baslama_tarih = new Date(ret.baslama_tarih);
          ret.bitis_tarih = new Date(ret.bitis_tarih);
          ret.tanzim_tarihi = new Date(ret.tanzim_tarihi);
          return ret;
        }),
        PolParametreList: teminatlar.map(x => ({
          parametre_adi: x.name,
          parametre_degeri: x.value,
          parametre_aciklama: x.description,
          parametre_tip: x.type,
          parametre_deger_list: x.type,
        })),
        guid: this.$store.state.login.agencyDetails.UserGuid,
        SubeKod: this.queryModel.subeKodu,
        KaynakKod: this.queryModel.kaynakKodu,
        AcenteNo: this.$store.getters.getAgencyState.Acente.Kodu,
        EmailAdresler: emails.join(';'),
      };
      let ret = await this.$store.dispatch('savePolicyAndParameterList', data);
      if (ret.status == 200) {
        eventBus.$emit('InfoSnackbar', {
          statePath: {
            Mesajlar: [
              {
                Tip: 'Bilgi',
                Mesaj:
                  'İşleminiz başarıyla gerçekleşmiştir. Otomatik Bedel Artış ekbelgeri oluştuğunda, mail ile bilgilendirileceksiniz.!',
              },
            ],
          },
        });
        await this.getHavuz();
        reset();
      } else {
        eventBus.$emit('InfoSnackbar', {
          statePath: {
            Mesajlar: [
              {
                Tip: 'Hata',
                Mesaj: 'İşlem hatası algılandı!',
              },
            ],
          },
        });
      }
    },
    reset() {
      this.queryModel = {
        sirketKod: 1,
      };
      this.policeler = [];
      this.filterPoliceler = [];
      this.havuzlar = [];
      this.filterHavuzlar = [];
      this.secilenPoliceler = [];
    },
    async sorgula(payload) {
      if (this.$refs.form.validate()) {
        this.queryModel.tanzimTarihBaslangic = payload.dates[0];
        this.queryModel.tanzimTarihBitis = payload.dates[1];
        this.queryModel.subeKodu = this.$store.getters.getAgencyState.Acente.Sube_Kod;
        this.queryModel.kaynakKodu = this.$store.getters.getAgencyState.Acente.Kaynak_Kod;
        this.queryModel.acenteNo = this.$store.getters.getAgencyState.Acente.Kodu;
        this.queryModel.tarifeKodu = payload.tarifeKodu;
        this.queryModel.aramaTipi = 'TanzimTarih';
        this.queryModel.key = '';

        await this.$store.dispatch('searchPolicyWithoutAdditionalDetail', this.queryModel);
        this.policeler = this.$store.getters.SearchWithoutAdditionalPolicy.Data;

        this.teminatlar = JSON.parse(
          JSON.stringify(getParameters.find(x => x.tariffCode.includes(payload.tarifeKodu)).parameters),
        );

        // this.filterPoliceler = Object.assign([], this.policeler);
        await this.getHavuz();
      }
    },
    async getHavuz() {
      const { subeKodu, kaynakKodu, acenteNo } = this.queryModel;
      await this.$store.dispatch('getPolicyPoolJobs', {
        subeKod: parseInt(subeKodu),
        kaynakKod: parseInt(kaynakKodu),
        acentaNo: acenteNo,
      });
      this.havuzlar = this.$store.getters.GetPolicyPoolJobs;
      this.filterHavuzlar = Object.assign([], this.havuzlar);
    },
  },
  computed: {
    breadcrumbsItems() {
      return [
        {
          text: 'Anasayfa',
          disabled: false,
          to: '/',
        },
        {
          text: 'Bedel Artış Havuzu',
          disabled: true,
          to: '/diger-islemler/bedel-artis-havuzu',
        },
      ];
    },
  },
  filters: {
    dateFormat(val) {
      console.log(val.getDate());
      return `${val.getDate() < 10 ? '0' + val.getDate() : val.getDate()}.${
        val.getMonth() + 1 < 10 ? '0' + (val.getMonth() + 1) : val.getMonth() + 1
      }.${val.getFullYear()}`;
    },
  },
  watch: {
    search(val) {
      this.c_policeler = val;
    },
    searchHavuz(val) {
      this.c_havuzlar = val;
    },
    havuzPagPage(val) {
      this.c_havuz_pages = Math.ceil(this.filterHavuzlar.length / val);
    },
  },
};
</script>
<style scoped></style>
